// extracted by mini-css-extract-plugin
export default {"wrapper":"FileUploaderTile_wrapper__VoVwu","title":"FileUploaderTile_title__gWPeg"};